
const TokenKey = 'token'

export function getToken () {
  return sessionStorage.getItem(TokenKey)
}

export function setToken (token) {
  return sessionStorage.setItem(TokenKey, token)
}

export function removeToken () {
  return sessionStorage.removeItem(TokenKey)
}

export function getUserId () {
    return sessionStorage.getItem('userId')
}

export function setUserId (userId) {
    return sessionStorage.setItem('userId', userId)
}

export function getLeaderFlag () {
    return sessionStorage.getItem('leaderFlag')
}

export function setLeaderFlag (leaderFlag) {
    return sessionStorage.setItem('leaderFlag', leaderFlag)
}

export function getUserAccount () {
    return sessionStorage.getItem('account')
}

export function setUserAccount (account) {
    return sessionStorage.setItem('account', account)
}

export function getUserPageCode () {
    return sessionStorage.getItem('pageCode')
}

export function setUserPageCode (pageCode) {
    return sessionStorage.setItem('pageCode', pageCode)
}

export function getUserPageName () {
    return sessionStorage.getItem('pageName')
}

export function setUserPageName (pageName) {
    return sessionStorage.setItem('pageName', pageName)
}

export function getUserOrg () {
    return sessionStorage.getItem('orgId')
}

export function setUserOrg (orgId) {
    return sessionStorage.setItem('orgId', orgId)
}

export function getUserLevel () {
    return sessionStorage.getItem('level')
}

export function setUserLevel (level) {
    return sessionStorage.setItem('level', level)
}

export function getUserAreaCode () {
    return sessionStorage.getItem('areaCode')
}

export function setUserAreaCode (areaCode) {
    return sessionStorage.setItem('areaCode', areaCode)
}

export function getUserAreaFlag () {
    return sessionStorage.getItem('areaFlag')
}

export function setUserAreaFlag (areaFlag) {
    return sessionStorage.setItem('areaFlag', areaFlag)
}

export function getModuleInfo () {
    return sessionStorage.getItem('moduleInfo')
}

export function setModuleInfo (moduleInfo) {
    return sessionStorage.setItem('moduleInfo', moduleInfo)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js